<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col cols="12" md="12">
        <v-row align="center" justify="space-around">
          <v-col cols="3"></v-col>
          <v-col class="text-h5 text-center" cols="12" md="3">
            <b style="color: #bf0529"> Operating in collaboration with</b>
          </v-col>
          <v-col class="text-h5 text-center" cols="12" md="3">
            <b>Sponsor</b></v-col
          >
          <v-col cols="3"></v-col>
        </v-row>
        <v-divider class="mb-1"></v-divider>

        <v-row align="center" justify="center">
          <v-col cols="3"></v-col>

          <v-col cols="12" md="3"
            ><v-row align="center" justify="space-around"
              ><v-img
                contain
                max-width="300px"
                max-height="60px"
                src="@/assets/sponsor1.png"
              ></v-img
            ></v-row>
          </v-col>
          <v-col cols="12" md="3"
            ><v-row align="center" justify="space-around"
              ><v-img
                contain
                max-width="146px"
                max-height="60px"
                src="@/assets/sponsor2.png"
              ></v-img>
            </v-row>
          </v-col>
          <v-col cols="3"></v-col>
        </v-row>

        <v-row align="center" justify="space-around">
          <v-col class="text-h5 text-center" cols="12" md="12">
            <b>Collaborators</b>
          </v-col>
        </v-row>
        <v-divider class="mb-1"></v-divider>
        <v-row align="center" justify="center">
          <v-col cols="12" md="10">
            <v-row align="center" justify="center">
              <v-col class="d-flex justify-center align-center" cols="6" md="2">
                <a
                  href="https://hutchinscenter.fas.harvard.edu/home"
                  target="blank"
                  ><img src="@/assets/sponsors2024/hunter.png" alt=""
                /></a>
              </v-col>
              <v-col class="d-flex justify-center align-center" cols="6" md="2">
                <a href="https://culturalagents.org/" target="blank"
                  ><img src="@/assets/sponsors2024/culturalAgent.png" alt=""
                /></a>
              </v-col>
              <v-col class="d-flex justify-center align-center" cols="6" md="2">
                <a
                  href="https://cervantesobservatorio.fas.harvard.edu/"
                  target="blank"
                  ><img src="@/assets/sponsors2024/client-6-2.png" alt=""/></a
              ></v-col>
              <v-col class="d-flex justify-center align-center" cols="6" md="2">
                <a href="https://rcc.harvard.edu/" target="blank"
                  ><img src="@/assets/sponsors2024/hrcc.jpg" alt=""/></a
              ></v-col>
<v-row justify="space-between">
  <v-col class="d-flex justify-center align-center" cols="6" md="2">
                <a href="https://www.umass.edu/digitalcenter/" target="blank"
                  ><img src="@/assets/sponsors2024/ndg.png" alt=""/></a
              ></v-col>
              <v-col class="d-flex justify-center align-center" cols="6" md="1">
                <a href="https://uees.edu.ec/" target="blank"
                  ><img src="@/assets/sponsors2024/finis.png" alt=""
                /></a>
              </v-col>
              <v-col class="d-flex justify-center align-center" cols="6" md="1">
                <a href="https://fundacionbotin.org/" target="blank"
                  ><img src="@/assets/sponsors2024/botin.png" alt=""/></a
              ></v-col>
              <v-col class="d-flex justify-center align-center" cols="6" md="1">
                <a
                  href="https://www.iies.es/"
                  target="blank"
                  ><img src="@/assets/sponsors2024/client-16.png" alt=""/></a
              ></v-col>
              <v-col class="d-flex justify-center align-center" cols="6" md="1">
                <a href="https://www.centrogarrigues.com/" target="blank"
                  ><img src="@/assets/sponsors2024/garriges.png" alt=""/></a
              ></v-col>
              <v-col class="d-flex justify-center align-center" cols="6" md="1">
                <a href="https://oei.int/" target="blank"
                  ><img src="@/assets/sponsors2024/oei.png" alt=""/></a
              ></v-col>
              <v-col class="d-flex justify-center align-center" cols="6" md="1">
                <a
                  href="http://www.usfq.edu.ec/Paginas/Inicio.aspx"
                  target="blank"
                  ><img src="@/assets/sponsors2024/client-14.png" alt=""/></a
              ></v-col>
              <v-col class="d-flex justify-center align-center" cols="6" md="1">
                <a
                  href="https://www.uniovi.es/"
                  target="blank"
                  ><img src="@/assets/sponsors2024/client-17.png" alt=""/></a
              ></v-col>
</v-row>

<v-row justify="space-between">
  <v-col class="d-flex justify-center align-center" cols="6" md="1">
                <a href="https://ascofame.org.co/moodle/" target="blank"
                  ><img src="@/assets/sponsors2024/colab-ascofame.png" alt=""
                /></a>
              </v-col>
              <v-col class="d-flex justify-center align-center" cols="6" md="1">
                <a href="https://usmp.edu.pe/" target="blank"
                  ><img src="@/assets/sponsors2024/colab-unisanmartin.png" alt=""
                /></a>
              </v-col>
              <v-col class="d-flex justify-center align-center" cols="6" md="1"
                ><a href="http://www.inaecu.com/" target="blank"
                  ><img src="@/assets/sponsors2024/client8.png" alt=""/></a
              ></v-col>
              <v-col class="d-flex justify-center align-center" cols="6" md="1">
                <a
                  href="https://www.universidadesdeinvestigacion.com/"
                  target="blank"
                  ><img src="@/assets/sponsors2024/client-12.png" alt=""/></a
              ></v-col>
              <v-col class="d-flex justify-center align-center" cols="6" md="1">
                <a
                  href="https://rudecolombia.edu.co/"
                  target="blank"
                  ><img src="@/assets/sponsors2024/colab-rudecolombia.png" alt=""/></a
              ></v-col>
              <v-col class="d-flex justify-center align-center" cols="6" md="1">
                <a href="https://www.ucsm.edu.pe/" target="blank"
                  ><img src="@/assets/sponsors2024/ucsm.gif" alt=""/></a
              ></v-col>
              <v-col class="d-flex justify-center align-center" cols="6" md="1">
                <a href="https://idea2.mit.edu/" target="blank"
                  ><img src="@/assets/sponsors2024/idea.png" alt=""/></a
              ></v-col>
              <v-col class="d-flex justify-center align-center" cols="6" md="1">
                <a href="https://www.unisabana.edu.co/" target="blank"
                  ><img src="@/assets/sponsors2024/client-18.png" alt=""/></a
              ></v-col>
</v-row>             
              
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  methods: {
    isMobile() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
